import clsx from "clsx";
import { FunctionComponent, Fragment } from "react";

import DuetLink from "@ui/components/navigation/DuetLink";
import { LinkProps } from "@ui/components/navigation/Footer/Footer";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import * as styles from "./FooterLinks.css";

interface Props {
  linkData?: LinkProps[][];
  showBrandLinks?: boolean;
}

const FooterLinks: FunctionComponent<Props> = ({
  linkData,
  showBrandLinks = true,
}) => {
  const analytics = useAnalytics();

  return (
    <div className={styles.container}>
      {linkData &&
        linkData.map((section: LinkProps[], sectionIdx: number) => {
          if (sectionIdx === 0 && !showBrandLinks) {
            return;
          }
          return (
            <Fragment key={sectionIdx}>
              <ul
                className={clsx(
                  styles.ul,
                  sectionIdx === 0 && styles.brandLinks,
                )}
              >
                {section.map((link: LinkProps, linkIdx: number) => {
                  if (link.component) {
                    return (
                      <li key={linkIdx} className={styles.li}>
                        {link.component}
                      </li>
                    );
                  } else if (link.title && link.href) {
                    return (
                      <li key={linkIdx} className={styles.li}>
                        <DuetLink
                          className={styles.link}
                          onClick={() =>
                            analytics?.emit({
                              event: "footer_click",
                              footer_click: { name: link.title },
                            })
                          }
                          rel="nofollow"
                          href={link.href}
                        >
                          {link.title}
                        </DuetLink>
                      </li>
                    );
                  }
                })}
              </ul>
            </Fragment>
          );
        })}
    </div>
  );
};

export default FooterLinks;
